export function snakeToTitleCase(input: string): string {
	return input
		.split('_')
		.map(
			(word) =>
				word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
		)
		.join(' ');
}

export function titleToSnakeCase(input: string): string {
	return input.trim().toLowerCase().replace(/\s+/g, '_');
}

export function deepOmit<T>(obj: T, keysToOmit: string[]): T {
	if (Array.isArray(obj)) {
		return obj.map((item) => deepOmit(item, keysToOmit)) as unknown as T;
	} else if (obj !== null && typeof obj === 'object') {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const result: any = {};
		for (const [key, value] of Object.entries(obj)) {
			if (!keysToOmit.includes(key)) {
				result[key] = deepOmit(value, keysToOmit);
			}
		}
		return result;
	}
	return obj;
}

export function getElipsisText(text: string, maxLength: number): string {
	const isTruncated = text.length > maxLength;
	const elipsisText = isTruncated
		? `${text.substring(0, maxLength)}...`
		: text;

	return elipsisText;
}
